import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Action, Badge } from 'hljd'
import { inject } from 'mobx-react'
import List from './List'
import { hashHistory } from 'react-router'
import { Button, Modal, message } from 'hljd'
import { HOTEL_SITE_RANKING_PATH } from '@components/Hotel/constant'
import { Upload } from 'hlj-components'
import ClipModal from '@common/ClipModal'
import style from '../style.module.less'

const Item = Action.Item

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      onChange,
      keys,
      toLink,
      verticalModalVisible,
      toggleVerticalImgModal,
      toggleClipModalVisible,
      clipModalVisible,
      currentVerticalImgRecord,
      onCliped,
      onDelete,
      clipVerticalImgUrl,
      unAuditNumber
    } = this.props.store
    const aspect = 500 / 1000
    return (
      <>
        <Action
          active={keys + ''}
          onChange={onChange}
          extra={
            <>
              {keys == 1 && (
                <Button
                  type="primary"
                  onClick={() => hashHistory.push(HOTEL_SITE_RANKING_PATH)}
                  style={{ marginRight: 10 }}
                >
                  场地排序
                </Button>
              )}

              <Button onClick={toLink}>发布场地</Button>
            </>
          }
        >
          <Item value="1">已上架</Item>
          <Item value="2">审核中</Item>
          <Item value="3">
            <Badge count={unAuditNumber} offset={[10, -5]}>
              <span style={{ fontSize: '16px' }}>审核未通过</span>
            </Badge>
          </Item>
          <Item value="4">已下架</Item>
        </Action>
        <Modal
          title="设置竖图"
          footer={null}
          visible={verticalModalVisible}
          width={300}
          onCancel={toggleVerticalImgModal(false)}
        >
          <div className={style.setImgs}>
            <Upload
              link={clipVerticalImgUrl}
              onDelete={onDelete}
              clipabled
              onCliped={onCliped}
              aspect={aspect}
              width={120}
              height={240}
              description={'选取本地图片'}
              onBeforeUp={async (up, file) => {
                return new Promise((resolve, reject) => {
                  Upload.checkSize(file, ({ width, height }) => {
                    if (width < 1080 || height < 675) {
                      message.warn(`宽>=1080，高>=675`)
                      reject(false)
                    } else {
                      resolve(true)
                    }
                  })
                })
              }}
            />
            <div
              className={style.useOldImg}
              onClick={toggleClipModalVisible(true)}
            >
              <div>选取宴会厅横图</div>
              <div>（建议）</div>
            </div>
            <ClipModal
              aspect={aspect}
              // clipConfig={clipConfig}
              onCliped={onCliped}
              visible={clipModalVisible}
              img={currentVerticalImgRecord.img}
              onCancel={toggleClipModalVisible(false)}
            />
          </div>
        </Modal>
        <List />
      </>
    )
  }
}
